export default __webpack_public_path__ + "static/media/projects.16ef36e5.png";